export default __webpack_public_path__ + "static/media/iIcon.4014f6eb.svg";